import { Injectable } from '@angular/core';

interface Scripts {
  name: string;
  src: string;
}

export const ScriptStore: Scripts[] = [
  { name: 'jquery', src: 'assets/plugins/jquery/dist/jquery.min.js' },
  { name: 'bootstrap', src: 'assets/plugins/bootstrap/dist/js/bootstrap.min.js' },
  { name: 'slick', src: 'assets/plugins/slick-carousel/slick/slick.min.js' },
  { name: 'filterizr', src: 'assets/plugins/filterzr/jquery.filterizr.min.js' },
  { name: 'scroll', src: 'assets/plugins/smooth-scroll/dist/js/smooth-scroll.min.js' },
  { name: 'popup', src: 'assets/plugins/magnific-popup/dist/jquery.magnific-popup.min.js' },
  { name: 'sticky', src: 'assets/plugins/Sticky/jquery.sticky.js' },
  { name: 'countTo', src: 'assets/plugins/count-to/jquery.countTo.js' },
  { name: 'wow', src: 'assets/plugins/wow/dist/wow.min.js' },
  { name: 'script', src: 'assets/js/script.js' }
];

declare var document: any;

@Injectable()
export class DynamicScriptLoaderService {

  private scripts: any = {};

  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      if (!this.scripts[name].loaded) {
        //load script
        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {  //IE
            script.onreadystatechange = () => {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    this.scripts[name].loaded = true;
                    resolve({script: name, loaded: true, status: 'Loaded'});
                }
            };
        } else {  //Others
            script.onload = () => {
                this.scripts[name].loaded = true;
                resolve({script: name, loaded: true, status: 'Loaded'});
            };
        }
        script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
        document.getElementsByTagName('app-root')[0].appendChild(script);
      } else {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      }
    });
  }

}
